import React from "react";

export default function SQLServer_COS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_COS</h1>
      <p>This is the SQLServer_COS component generated from the SQL JSON.</p>
    </div>
  );
}
